import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { practitionerService } from '../services/api';
import { Practitioner } from '../types';
import Layout from '../components/Layout';
import '../styles/PractitionerList.css';

const PractitionerList: React.FC = () => {
  const [practitioners, setPractitioners] = useState<Practitioner[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPractitioners = async () => {
      try {
        setLoading(true);
        const data = await practitionerService.getAllPractitioners();
        setPractitioners(data);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch practitioners');
        setLoading(false);
      }
    };

    fetchPractitioners();
  }, []);

  if (loading) {
    return (
      <Layout>
        <div className="loading">Loading practitioners...</div>
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout>
        <div className="error">{error}</div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="practitioner-container">
        <h2>🧑‍⚕️ Practitioner List</h2>

        {practitioners.length > 0 ? (
          <div className="practitioner-grid">
            {practitioners.map((practitioner) => (
              <div key={practitioner.id} className="practitioner-card">
                <div className="practitioner-header">
                  <h3>Dr. {practitioner.fname} {practitioner.lname}</h3>
                  <span className="specialty">{practitioner.specialty}</span>
                </div>
                <div className="practitioner-body">
                  <p><strong>Organization:</strong> {practitioner.organization}</p>
                  <p><strong>License:</strong> {practitioner.state_license_number}</p>
                  <p><strong>Email:</strong> {practitioner.email}</p>
                  <p><strong>Phone:</strong> {practitioner.phone}</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="no-data">No practitioners found.</p>
        )}

        {/* <div className="back-btn">
          <Link to="/dashboard">
            <button>⬅️ Back to Dashboard</button>
          </Link>
        </div> */}
      </div>
    </Layout>
  );
};

export default PractitionerList;